module.exports = __webpack_public_path__ + "static/media/03-banner-03-saccaro-mobile@2x.432006bf.jpg";